import React, { memo, useCallback } from 'react';
import FormColorControl from './FormColorControl';
import { IColor } from '../../interfaces';
import { formActions, useAppDispatch, useAppSelector } from '../../data/store';
import FormRangeControl from './FormRangeControl';

const Stroke = () => {

    const dispatch = useAppDispatch();

    const strokeWidth = useAppSelector(store => store.form.strokeWidth);
    const strokeColor = useAppSelector(store => store.form.strokeColor);
    const hasStroke = useAppSelector(store => store.form.hasStroke);

    const updateStrokeColor = useCallback((updatedColor: IColor) => {
        dispatch(
            formActions.main({
                strokeColor: updatedColor,
                hasStroke: true,
            })
        );
    }, [dispatch]);

    const updateHasStroke = useCallback( () => {
        dispatch(
            formActions.main({
                hasStroke: !hasStroke,
            })
        );
    }, [dispatch, hasStroke]);


    const updateStrokeWidth = useCallback((updatedValue: number) => {
        dispatch(
            formActions.main({
                strokeWidth: updatedValue,
            })
        );
    }, [dispatch]);

    return (
        <>
            <div className="flex items-center">
                <FormColorControl
                    title={ 'Stroke Color' }
                    rgbaColor={ strokeColor }
                    onChange={ updateStrokeColor }
                />

                <label className="ml-4 mt-3">
                    <input
                        type="checkbox"
                        checked={ hasStroke }
                        className="mr-2"
                        onChange={ updateHasStroke }
                    />
                    <span>Enable</span>
                </label>
            </div>

            <FormRangeControl
                title={ 'Stroke Width' }
                value={ strokeWidth }
                min={ 0.1 }
                max={ 5 }
                onChange={ updateStrokeWidth }
            />
        </>
    )
};

export default memo(Stroke);